"use client";

import Image from "next/image";
import { Brain, Rocket, ShieldCheck, Users } from "lucide-react";

const features = [
  {
    icon: Brain,
    title: "AI-Powered Solutions",
    description: "Smarter automation with the power of AI and data.",
  },
  {
    icon: Rocket,
    title: "Agile & Scalable Delivery",
    description: "Rapid, flexible and scalable solutions that grow with you.",
  },
  {
    icon: ShieldCheck,
    title: "Secure & Future-Ready",
    description: "Enterprise-grade security for a future-ready tomorrow.",
  },
  {
    icon: Users,
    title: "Client-First Approach",
    description: "Your goals, our mission. We move forward together.",
  },
];

export default function WhyTychoSection() {
  return (
    <section className="relative overflow-hidden bg-background-primary px-2! md:px-6! py-4! ">
      <div className="relative mx-auto !w-full   overflow-hidden rounded-md   bg-contain bg-right bg-no-repeat">
        <div className="relative block lg:hidden w-full h-[260px] sm:h-[340px]">
          <Image src="/images/whyTchoSection.webp" alt="why tycho" fill priority className="object-cover object-right" />
        </div>

        <div className="absolute inset-0 w-full h-[100%] top-0 hidden lg:block">
          <Image src="/images/whyTchoSection.webp" alt="why tycho" fill priority className="object-contain object-right " />
        </div>

        {/* <div
          className="absolute inset-0 z-10 hidden lg:block"
          style={{
            background: "var(--hero-overlay-gradient)",
          }}
        /> */}

        <div className="relative z-10 mx-auto grid items-center gap-16! lg:grid-cols-2 p-10!">
          <div>
            <div className="mb-6! flex items-center gap-4!">
              <span className="text-sm font-semibold uppercase tracking-[0.3em] text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">Why Tycho?</span>

              <div className="h-px! w-24  bg-gradient-to-r from-cyan-400 to-purple-600 " />
            </div>

            <h2 className="max-w-2xl text-4xl font-bold leading-tight text-text-primary md:text-6xl">
              We Turn Ideas Into
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">Intelligent Solutions</span>
            </h2>

            <p className="mt-8! max-w-xl text-lg leading-8 text-text-secondary">
              We combine technology, creativity, and strategy to build digital experiences that drive real business impact.
            </p>
            <div className="mt-12! grid! gap-8! border-t! border-white/10! pt-8! md:grid-cols-2! xl:grid-cols-4!">
              {features.map((feature, index) => {
                const Icon = feature.icon;

                return (
                  <div key={index} className="group relative">
                    <div className="mb-5! flex! items-center! gap-3!">
                      <div className="h-px! w-8! bg-gradient-to-r! from-violet-500! to-cyan-400! transition-all! duration-500! group-hover:w-12!" />

                      <span className="text-[10px]! tracking-[0.25em]! text-white/30!">0{index + 1}</span>
                    </div>
                    <div className="mb-5! flex! h-12! w-12! items-center! justify-center! rounded-xl! border! border-border-secondary bg-white/[0.03] backdrop-blur-md! transition-all! duration-500! group-hover:border-cyan-400/30! group-hover:bg-cyan-400/[0.04]!">
                      <Icon className="h-5! w-5! text-violet-400! transition-all! duration-500! group-hover:text-cyan-300!" />
                    </div>

                    <h3 className="text-[18px]! font-semibold! tracking-[-0.02em]! text-text-primary">{feature.title}</h3>

                    <p className="mt-3! max-w-[240px]! text-[14px]! leading-7! text-text-secondary">{feature.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
